import {
  FeedbackStatus,
  ReportStages,
  ReportStatuses,
} from 'donor/portal/pages/FeedbackDashboard/api';

export const PAGE_SIZE = 10;

/** Question IDs used to project answers onto the card UI. */
export const QUESTION_IDS = {
  description: 1,
  causeArea: 40002,
  impactModel: 40003,
  successIndicators: 40010,
  reportingCadence: 110001,
  frequency: 110005,
  duration: 110006,
} as const;

export const STATUS_OPTIONS: FeedbackStatus[] = [...ReportStatuses];
export const STAGE_OPTIONS = [...ReportStages];
export const BB_STATUS_OPTIONS: FeedbackStatus[] = [
  'Draft',
  'Final Updates Needed',
  'Published',
  'Finalized',
];

export const STAGE_LABEL: Record<string, string> = {
  INITIAL: 'Initial',
  INTERIM: 'Interim',
  FINAL: 'Final',
};

export const REPORTING_TYPE_LABEL: Record<string, string> = {
  FULL: 'Full Reporting',
  LIGHT: 'Impact Snapshot',
  SUPER_LIGHT: 'Impact Snapshot (Lite)',
};
